import { Component, Input, inject, Output, EventEmitter } from '@angular/core';
import { Pages } from "@constants/pages/Pages";
import { TabService } from "@services/tabs/TabService";
import { CerrixDialogService } from "@app/shared/organisms/cerrix-dialog/cerrix-dialog-service.component";
import { MatIconModule } from "@angular/material/icon";
import { CerrixDialogComponent } from "@app/shared/organisms/cerrix-dialog/cerrix-dialog.component";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";
@Component({
    selector: 'add-new-risk-dialog',
    templateUrl: './add-new-risk-dialog.component.html',
    styleUrls: ['./add-new-risk-dialog.component.scss'],
    imports: [MatIconModule, CerrixDialogComponent, CerrixButtonComponent],
})
export class AddNewRiskDialogComponent{
    private _tabs = inject(TabService);
    pages = inject(Pages);

    @Input() public name: string
    @Output() onCreateNewRisk: EventEmitter<void> = new EventEmitter();
    showCreai = false;
    creaiGeneratingRisks: boolean = false;
    creaiDialogOption: "manual" | "ai" = "manual";

    private _dialogService = inject(CerrixDialogService);

    newRiskChoice() {
        switch (this.creaiDialogOption) {
            case "manual":
                this._dialogService.closeDialog("addNewRisk");
                this.onCreateNewRisk.emit();
                break;
            case "ai":
                this._dialogService.closeDialog("addNewRisk");
                this._dialogService.openDialog("generateAiRisks");
                break;
        }
    }

    closeAddNewRiskDialog() {
        this._dialogService.closeDialog("addNewRisk");
    }
}
